import * as React from 'react';
import { ToggleSwitch, Checkbox } from '../../../../../components/forms';
import NextPreviousButtons from '../../NextPreviousButtons';
import Utils from '../../../../../common/utils';

interface Props {
	questions: any;
	questionnaire: any;
	onQuestionnaireBlur: (value?: {}) => void;
	onQuestionnaireChange: (value?: {}) => void;
	nextStep: (e: any) => void;
	prevStep: (e: any) => void;
}
const MedicalQuestion5: React.StatelessComponent<Props> = props => {
	const { questionnaire, onQuestionnaireBlur, onQuestionnaireChange } = props;
	const isNextDisabled = () => {
		if (questionnaire.familyDiagnosis == null || questionnaire.familyKidneyDisease == null) {
			return true;
		} else {
			return false;
		}
	};

	const onUnknownBlur = (e: any, name: string) => {
		const value = Utils.parseValueFromEvent(e);
		const questionnaireEvent = {
			target: {
				name: name,
				value: value ? 'Unknown' : null,
				type: 'custom'
			}
		};

		onQuestionnaireBlur(questionnaireEvent);
	};
	const onUnknownChange = (e: any, name: string) => {
		const value = Utils.parseValueFromEvent(e);
		const questionnaireEvent = {
			target: {
				name: name,
				value: value ? 'Unknown' : null,
				type: 'custom'
			}
		};

		onQuestionnaireChange(questionnaireEvent);
	};

	return (
		<div>
			<ToggleSwitch
				labelText={props.questions.familyDiagnosis}
				name="familyDiagnosis"
				onChildren="Yes"
				offChildren="No"
				onBlur={onQuestionnaireBlur}
				onChange={onQuestionnaireChange}
				checked={questionnaire.familyDiagnosis}
				className="toggle-yes-no"
			/>
			<div className="form-group">
				<Checkbox
					name="familyDiagnosisUnknown"
					label="I do not know my biological parents or siblings"
					value="Unknown"
					checked={questionnaire.familyDiagnosis === 'Unknown'}
					onBlur={e => onUnknownBlur(e, 'familyDiagnosis')}
					onChange={e => onUnknownChange(e, 'familyDiagnosis')}
				/>
			</div>
			<ToggleSwitch
				labelText={props.questions.familyKidneyDisease}
				name="familyKidneyDisease"
				onChildren="Yes"
				offChildren="No"
				onBlur={onQuestionnaireBlur}
				onChange={onQuestionnaireChange}
				checked={questionnaire.familyKidneyDisease}
				className="toggle-yes-no"
			/>
			<div className="form-group">
				<Checkbox
					name="familyKidneyDiseaseUnknown"
					label="I do not know my biological parents or siblings"
					value="Unknown"
					checked={questionnaire.familyKidneyDisease === 'Unknown'}
					onBlur={e => onUnknownBlur(e, 'familyKidneyDisease')}
					onChange={e => onUnknownChange(e, 'familyKidneyDisease')}
				/>
			</div>
			<NextPreviousButtons nextStep={props.nextStep} prevStep={props.prevStep} isNextDisabled={isNextDisabled} />
		</div>
	);
};

export default MedicalQuestion5;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/quoting/enrollment/create-your-account/medicalQuestions/medicalQuestion5/FamilyHistory.tsx